module.exports = __webpack_public_path__ + "static/media/NEWS_51pegbFellow.709e8b92.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/NEWS_51pegbFellow.png
// module id = 176
// module chunks = 0